<template>
    <div>
        <!-- 顶部导航 -->
        <NavTop></NavTop>
        <!-- 人力资源许可证 -->
        <div class="permit row">
            <img src="@/assets/images/renliziyuanxukezheng.png" style="width: 100%;">
        </div>
        <!-- 底部 -->
        <Footer></Footer>
    </div>
</template>

<script>
import NavTop from '@/components/NavTop.vue'
import Footer from '@/components/Footer.vue'

export default {
    name: 'LaPermit',
    components: { NavTop, Footer },
    data() {
        return {
        }
    },
    mounted() {

    },
    activated() {

    },
    methods: {


    }

}
</script>

<style scoped>
.permit {
    width: 1200px;
    height: auto;
    margin: 20px auto;
    justify-content: space-between;
    position: relative;
}
</style>
